export function taskSetSignature(tasks) {
  if (!Array.isArray(tasks)) return "";
  return JSON.stringify(
    tasks.map((task) => ({
      type: task?.type || "",
      data: task?.data ?? null,
    }))
  );
}

export function generateDifferentTaskSet(generateTasks, currentTasks, maxAttempts = 5) {
  if (typeof generateTasks !== "function") return null;

  const currentSignature = taskSetSignature(currentTasks);
  let latestCandidate = null;

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const candidate = generateTasks();
    if (!Array.isArray(candidate) || candidate.length === 0) continue;

    latestCandidate = candidate;
    if (taskSetSignature(candidate) !== currentSignature) return candidate;
  }

  return latestCandidate;
}
